import React from 'react';
import styles from './Spinner.module.css';
import spinerLight from '../assets/spiner-black.svg';
import spinerDark from '../assets/spiner-white.svg';

const Spinner = ({ darkMode, isButton = false, isInline = false, size = 'large' }) => {
  /* $& */
  const spinnerSrc = darkMode ? spinerDark : spinerLight;
  let spinnerClass;

  if (isButton) {
    spinnerClass = `${styles.spinnerButton} ${styles[size]}`;
  } else if (isInline) {
    spinnerClass = `${styles.spinnerInline} ${styles[size]}`;
  } else {
    spinnerClass = `${styles.spinner} ${styles[size]}`;
  }

  if (isInline) {
    return (
      <div className={styles.inlineWrapper}>
        <img src={spinnerSrc} alt="Loading..." className={spinnerClass} />
      </div>
    );
  }

  if (isButton) {
    return (
      <div className={styles.mirroredWrapperButton}>
        <img src={spinnerSrc} alt="Loading..." className={spinnerClass} />
      </div>
    );
  }

  return (
    <div className={`${styles.spinnerContainer} ${styles.mirroredWrapper}`}>
      <img src={spinnerSrc} alt="Loading..." className={spinnerClass} />
    </div>
  );
};

export default Spinner;